import { MbscCalendarEvent, momentTimezone } from "@mobiscroll/react";
import moment from "moment-timezone";
import { DateType, getDateMoment } from "./dateHelper";

// Mobiscroll's date wrapper reads this plugin instance when constructing zoned dates.
momentTimezone.moment = moment;
export const destinationTimezonePlugin = momentTimezone;

/** Calendar edits can return ISO strings or Mobiscroll's zoned Date wrapper. */
export function getCalendarTimestamp(value: MbscCalendarEvent["start"]): number {
    if (value && typeof value === "object" && "getTime" in value) return value.getTime();
    return getDateMoment(value as DateType).valueOf();
}
